export const getBoundingClientRect = (element) => {
  const { top, right, bottom, left, width, height, x, y } = element.getBoundingClientRect();
  return { top, right, bottom, left, width, height, x, y };
};

//function to find country from url
export const getCountryFromUrl = (forceCountry) => {
  if (forceCountry) return forceCountry;

  const href = window.location.href;

  if (href.includes(".us.")) return "us";
  if (href.includes(".au")) return "aus";
  if (href.includes(".ie")) return "ie";
  return "uk";
};

//function to find country from url
export const getEnvironment = () => {
  const href = window.location.href;

  if (href.includes("staging")) return "staging";
  if (href.includes("localhost")) return "development";
  return "production";
};

export const getCookieyesId = (environment) => {
  let cookieyesId;

  if (environment === "production") {
    cookieyesId = "79e58d0c851ca2b9efca4ace";
  } else if (environment === "staging") {
    cookieyesId = "0c105a51c91b60bcf9796efb";
  }

  return cookieyesId;
};

//capatlise uppercase txt
export const capitalize = (str) => {
  if (!str) return str;
  const stringValue = typeof str === "string" ? str : String(str);
  return stringValue.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase());
};

//create player map from players array
export const createPlayerMap = (players) => {
  if (!players?.length) return {};

  return players.reduce((acc, p) => {
    acc[p.id] = p.name;
    return acc;
  }, {});
};

//replay event types
export const REPLAY_TYPES = new Set([100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112]);

//format special game names
export const formatGameName = (name) => {
  if (name === "DONKEYDERBY") return "DONKEY DERBY";
  if (name === "SNAKESANDLADDERS") return "SNAKES AND LADDERS";
  return name;
};

//parse completed games from newsfeed
export const parseCompletedGames = (newsfeed, includeOche = false) => {
  if (!newsfeed?.length) return [];

  const activeGames = {};
  const completedGames = [];

  for (const event of newsfeed) {
    const key = `${event.oche}-${event.game}`;

    // Game start (type 1)
    if (event.type === 1) {
      activeGames[key] = {
        name: formatGameName(event.game),
        oche: event.oche,
        startTime: event.date,
        replays: [],
      };
      continue;
    }

    const game = activeGames[key];
    if (!game) continue;

    // Action replays (types 100-112)
    if (REPLAY_TYPES.has(event.type) && event.video_url) {
      game.replays.push(event);
      continue;
    }

    // Game complete (type 14)
    if (event.type === 14) {
      try {
        const results = JSON.parse(event.info);
        const completedGame = {
          name: game.name,
          startTime: game.startTime,
          endTime: event.date,
          first: results.first || [],
          second: results.second || [],
          third: results.third || [],
          players: results.players_in_game || [],
          replays: game.replays,
        };

        if (includeOche) {
          completedGame.oche = game.oche;
        }

        completedGames.push(completedGame);
        delete activeGames[key];
      } catch (err) {
        console.error("Failed to parse podium info:", err);
      }
    }
  }

  return completedGames.sort((a, b) => new Date(a.startTime) - new Date(b.startTime));
};

//parse text for bold and underline markers
export const makeLinkMarker = (href, text) => `[[L:${href}|${text}]]`;

export const scrollToSection = (sectionId, event) => {
  event.preventDefault();

  const id = sectionId.startsWith("#") ? sectionId.slice(1) : sectionId;
  const target = document.getElementById(id);

  if (target) {
    target.scrollIntoView({ behavior: "smooth", block: "start" });
  }
};

export const getTimeOfDay = (date) => {
  const h = date.getHours();
  if (h < 12) return "morning";
  if (h < 14) return "lunch";
  if (h < 17) return "afternoon";
  if (h < 20) return "evening";
  return "night";
};

export const getLongestGame = (games) =>
  games
    .filter((g) => g.startTime && g.endTime)
    .reduce((longest, game) => {
      const duration = (new Date(game.endTime) - new Date(game.startTime)) / 60000;
      if (!longest || duration > longest.duration) {
        return { game, duration };
      }
      return longest;
    }, null);
